{
  "cols": 15,
  "rows": 14,
  "terrain": {
    "7,0": "b", "8,0": "b",
    "5,1": "b", "6,1": "b", "7,1": "b", "8,1": "m", "9,1": "m", "10,1": "h", "13,1": "a",
    "4,2": "b", "5,2": "b", "6,2": "b", "7,2": "l", "8,2": "l", "9,2": "m", "10,2": "h", "11,2": "h", "13,2": "b",
    "3,3": "p", "4,3": "b", "5,3": "b", "6,3": "p", "7,3": "l", "8,3": "l", "9,3": "t", "10,3": "m", "11,3": "m",
    "2,4": "a", "3,4": "p", "4,4": "p", "5,4": "p", "6,4": "p", "7,4": "p", "8,4": "r", "9,4": "p", "10,4": "t", "11,4": "h", "12,4": "c",
    "1,5": "a", "2,5": "a", "3,5": "p", "4,5": "p", "5,5": "p", "6,5": "p", "7,5": "p", "8,5": "r", "9,5": "p", "10,5": "p", "11,5": "t", "12,5": "a",
    "2,6": "a", "3,6": "a", "4,6": "p", "5,6": "p", "6,6": "b", "7,6": "p", "8,6": "r", "9,6": "p", "10,6": "p", "11,6": "p",
    "4,7": "a", "5,7": "p", "6,7": "p", "7,7": "p", "8,7": "r", "9,7": "r", "10,7": "p", "11,7": "p", "12,7": "a", "13,7": "a",
    "4,8": "a", "5,8": "a", "6,8": "p", "7,8": "p", "8,8": "p", "9,8": "r", "10,8": "p", "11,8": "p", "12,8": "a",
    "5,9": "a", "6,9": "a", "7,9": "a", "8,9": "a", "9,9": "r", "10,9": "a",
    "6,10": "a", "7,10": "a",
    "1,11": "a", "2,11": "c",
    "1,12": "a", "2,12": "a"
  },
  "tiles": [
    {"id":"mina","kind":"mina","name":"Mina de hierro","cells":[[10,2]],"ore":"iron","product":"iron_ore","ports":[[[10,2],"S","out"]]},
    {"id":"fundicion","kind":"fundicion","name":"Fundición termal","cells":[[10,4]],"product":"plate","ports":[[[10,4],"N","in"],[[10,4],"E","in"],[[10,4],"S","out"]]},
    {"id":"taller","kind":"taller","name":"Taller de circuitos (unida)","cells":[[9,5],[9,6],[10,6]],"product":"circuit","ports":[[[10,6],"N","in"],[[9,5],"W","in"],[[9,5],"N","out"]]},
    {"id":"lab","kind":"lab","name":"Laboratorio","cells":[[5,4]],"product":"sample","ports":[[[5,4],"E","in"]]},
    {"id":"bomba","kind":"bomba","name":"Bomba de agua","cells":[[6,3]],"product":"water","ports":[[[6,3],"E","out"]]},
    {"id":"muelle","kind":"muelle","name":"Muelle","cells":[[5,9]],"product":"cu_ore","ports":[[[5,9],"W","in"],[[5,9],"E","out"]]},
    {"id":"islote","kind":"mina","name":"Mina de cobre (islote)","cells":[[2,11]],"ore":"copper","product":"cu_ore","ports":[[[2,11],"E","out"]]}
  ],
  "routes": [
    {"kind":"road","name":"Camión","pts":[[10.5,3],[10.5,4]],"at":0.45},
    {"kind":"road","name":"Camión","pts":[[10.5,5],[10.5,6]],"at":0.5},
    {"kind":"rail","name":"Tren","pts":[[6,9.5],[7.5,9.5],[7.5,8.5],[11.5,8.5],[11.5,4.5],[11,4.5]],"at":0.62},
    {"kind":"barge","name":"Barcaza","pts":[[7,3.5],[8.5,3.5],[8.5,5.5],[9,5.5]],"at":0.55},
    {"kind":"boat","name":"Barco","curve":[[3,11.5],[4.7,11.4],[5,9.5]],"at":0.5},
    {"kind":"drone","name":"Dron","curve":[[9.5,5],[7.6,3.4],[6,4.5]],"at":0.3}
  ],
  "fog": ["12,4","12,7","3,4","4,6","5,1","8,0","5,7","8,9","13,2","10,9","2,5","7,1","7,7","7,10","4,2","3,3","5,6","3,6","8,2","2,4","13,1","1,5","13,7","6,1","7,0","6,7","7,6","12,5","4,7","3,5","12,8","8,1","9,9","2,6","6,6","7,5"],
  "locks": {"11,4":120,"6,5":60,"9,3":90,"4,8":45},
  "buyTarget": "6,5",
  "goal": [13,7]
}
